import { Route, Routes } from 'react-router-dom';
import { RedirectToSignIn, SignedIn, SignedOut, useClerk } from '@clerk/clerk-react';
import { useReactiveVar } from '@apollo/client/react';
import { UserDetailsProps, reactiveVars } from '@brainpool/apollo-connect';
import { CustomThemeProvider } from '@brainpool/themes';
import { Box } from '@mui/material';
import { Button, HeaderV2, Typography } from '@brainpool/components';
import { HomePage } from './pages/HomePage';
import theme from './theme/theme';

export function App() {
  const { signOut } = useClerk();
  const userDetails = useReactiveVar<UserDetailsProps | null>(reactiveVars.userDetails);

  return (
    <CustomThemeProvider theme={theme}>
      <Box
        sx={{
          backgroundColor: 'background.default',
          borderBottom: '1px solid',
          borderColor: 'grey.200',
          position: 'relative',
          zIndex: 2000,
        }}
      >
        <HeaderV2
          position="relative"
          data-testid="header"
          shadow={false}
          logo={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  background:
                    'radial-gradient(circle at 40% 40%, #5E5BA8 20%, #76A5B2 45%, #77C9B8 70%, #9dd9cc 100%)',
                }}
              />
              <Typography
                variant="h6"
                sx={{ mb: 0, fontWeight: 700, color: 'text.primary', letterSpacing: '-0.02em' }}
              >
                brainpool
              </Typography>
            </Box>
          }
        >
          {userDetails && (
            <Typography variant="body2" sx={{ color: 'text.secondary', mr: 2 }}>
              {userDetails.firstName}
            </Typography>
          )}
          <Button
            variant="outlined"
            size="small"
            onClick={() => signOut({ redirectUrl: '/' })}
            sx={{ borderColor: 'grey.300', color: 'text.secondary' }}
          >
            Sign out
          </Button>
        </HeaderV2>
      </Box>

      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
      <SignedIn>
        <Box data-testid="content">
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </Box>
      </SignedIn>
    </CustomThemeProvider>
  );
}

export default App;
